import React, { useEffect, useState } from "react";
import "../static/css/Team.css";
import { Link } from "react-router-dom";
import axios from "axios";
import API_URL from "../config";

function truncateText(text, limit) {
  const words = text.split(" ");
  return words.length > limit ? words.slice(0, limit).join(" ") + "..." : text;
}

function Team() {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_URL}/team`)
      .then((response) => {
        console.log("Fetched team members:", response.data);
        setTeamMembers(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching team members:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="team-container">
      <div className="team-box">
        <div className="team-demo">
          <div className="team-members-grid">
            {teamMembers.map((member, index) => {
              const imageUrl = `${API_URL}${member.image.replace(
                /\\/g,
                "/"
              )}`;
              console.log("Member Image URL:", imageUrl);
              return (
                <div className="card text-center" key={member.id}>
                  <img
                    className="rounded-image"
                    src={imageUrl}
                    alt={`${member.name}`}
                    style={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "50%",
                      justifySelf: "center",
                      margin: "5px auto",
                    }}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{member.name}</h5>
                    <h6 className="card-subtitle mb-1 text-muted">{member.role}</h6>
                    {member.credentials && (
                      <p className="card-credentials" style={{ fontSize: "12px", marginTop: "3px", fontStyle: "italic" }}>
                        {truncateText(member.credentials, 30)}
                      </p>
                    )}
                    <p className="card-text">
                      {truncateText(member.short_description, 50)}
                    </p>
                    {member.email && (
                      <p className="card-contact" style={{ fontSize: "12px", marginTop: "5px" }}>
                        <strong>📧</strong> <a href={`mailto:${member.email}`}>{member.email}</a>
                      </p>
                    )}
                    {member.phone && (
                      <p className="card-contact" style={{ fontSize: "12px", marginTop: "3px" }}>
                        <strong>📱</strong> <a href={`tel:${member.phone}`}>{member.phone}</a>
                      </p>
                    )}
                    {member.linkedin_url && (
                      <p className="card-contact" style={{ fontSize: "12px", marginTop: "3px" }}>
                        <strong>🔗</strong> <a href={member.linkedin_url} target="_blank" rel="noopener noreferrer">LinkedIn</a>
                      </p>
                    )}
                    <Link to={`/member/${member.id}`}>
                      <button className="btn-team">Read More</button>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Team;
